import React, { useRef, useState } from 'react'
import clsx from 'clsx'
import Icon from '../Icon'
import Button from '../Button'
import Heading from '../Heading'

import './contactform.scss'
import { navigate } from 'gatsby'
import scrollTo from 'gatsby-plugin-smoothscroll'

function encode(data) {
  const formData = new FormData()
  for (const key of Object.keys(data)) {
    formData.append(key, data[key])
  }
  return formData
}

export const ContactForm = ({ otherClasses, toggleCancel, nodes }) => {
  const contactFormClasses = clsx(
    otherClasses,
    'max-w-[720px] bg-[#20242E] overflow-y-auto h-full'
  )

  const messageRef = useRef('')
  const [state, setState] = useState({
    name: '',
    phone: '',
    email: '',
    'what-can-we-help-you-with': '',
    description: '',
    optIn: true,
  })

  const handleSubmit = async (e) => {
    e.preventDefault()
    const form = e.target
    try {
      await fetch('/', {
        method: 'POST',
        body: encode({
          'form-name': form.getAttribute('name'),
          ...state,
        }),
      })
      messageRef.current.innerHTML =
        'Thank you for your submission! We will get in touch with you shortly.'
      setTimeout(() => {
        messageRef.current.innerHTML = null
      }, 10000)
      setState({
        name: '',
        phone: '',
        email: '',
        'what-can-we-help-you-with': '',
        description: '',
        optIn: true,
      })
      scrollTo('#form-top')
      form.reset()
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <div
      className={contactFormClasses}
      data-testid="contact-form"
      id="form-top"
    >
      <div className="flex justify-between py-[18px] px-6 border-b-[1px] border-b-gray-200">
        <a href="tel:(619) 359-4107" className="flex items-center gap-2">
          <Icon icon="phone" iconHeight={20} iconWidth={20} />
          <p className="font-Gentium-Plus text-primary_biege_600 text-base font-bold leading-6">
            (619) 359-4107
          </p>
        </a>
        <button className="text-right" onClick={() => toggleCancel()}>
          <Icon icon="cancel-icon" iconHeight={20} iconWidth={20} />
        </button>
      </div>
      <div className="pb-10 px-4 md:px-[84px] w-full mt-8">
        <Heading
          type="h3"
          otherClasses="text-left text-[28px] lg:text-[30px] leading-normal font-Eczar font-bold mb-4 text-primary_biege_600"
        >
          Contact Our Bay Ink Crew
        </Heading>
        <p className="text-base text-gray-50 font-Gentium-Plus leading-6 font-normal">
          Let’s talk tattoos and piercings! Shoot us a question, inspiration,
          comment, or anything else you’d like to chat about with our team.
          We’ll be in touch shortly!
        </p>
        <form
          method="post"
          onSubmit={handleSubmit}
          action=""
          name="Contact Us"
          className={clsx('w-full mt-5 md:mt-8')}
        >
          <p
            className="font-Cabin text-primary_purple_600  text-base font-bold mb-4"
            ref={messageRef}
          ></p>

          <div className="mb-6">
            <label
              htmlFor="name"
              className="font-Gentium-Plus text-sm font-semibold text-gray-50 "
            >
              Name
            </label>
            <input
              name="name"
              id="name"
              required
              type="text"
              value={state.name}
              onChange={(e) =>
                setState((prev) => ({
                  ...prev,
                  name: e.target.value,
                }))
              }
              className="w-full border-[1px] pl-4 font-Cabin border-gray-300 rounded-[2px] h-12 mt-2 outline-none focus:outline-offset-0 focus:outline-[3px]  bg-transparent focus:outline-[#9E74EC]/[0.3] focus:border-purple-600 text-gray-50"
            />
          </div>
          <div className="mb-6 flex flex-col md:flex-row gap-5 lg:gap-[21px]">
            <div className="w-full md:w-2/4">
              <label
                htmlFor="phone"
                className="font-Gentium-Plus text-sm font-semibold text-gray-50 "
              >
                Phone Number
              </label>
              <input
                name="phone"
                id="phone"
                required
                value={state.phone}
                onChange={(e) =>
                  setState((prev) => ({
                    ...prev,
                    phone: e.target.value,
                  }))
                }
                type="number"
                className="w-full border-[1px] pl-4 font-Cabin border-gray-300 rounded-[2px] h-12 mt-2 outline-none focus:outline-offset-0 focus:outline-[3px]  bg-transparent focus:outline-[#9E74EC]/[0.3] focus:border-purple-600 text-gray-50 input_number_hide_arrows"
              />
            </div>
            <div className="w-full md:w-2/4">
              <label
                htmlFor="email"
                className="font-Gentium-Plus text-sm font-semibold text-gray-50  "
              >
                Email Address
              </label>
              <input
                name="email"
                id="email"
                required
                type="email"
                value={state.email}
                onChange={(e) =>
                  setState((prev) => ({
                    ...prev,
                    email: e.target.value,
                  }))
                }
                className="w-full border-[1px] pl-4 font-Cabin border-gray-300 rounded-[2px] h-12 mt-2 outline-none focus:outline-offset-0 focus:outline-[3px]  bg-transparent focus:outline-[#9E74EC]/[0.3] focus:border-purple-600 text-gray-50"
              />
            </div>
          </div>
          <div className="w-full flex flex-col gap-2 mb-6">
            <label
              htmlFor="what-can-we-help-you-with"
              className="font-Gentium-Plus text-sm font-semibold text-gray-50"
            >
              What Can We Help You With?
            </label>
            <select
              name="what-can-we-help-you-with"
              id="what-can-we-help-you-with"
              type="text"
              required
              value={state['what-can-we-help-you-with']}
              onChange={(e) =>
                setState((prev) => ({
                  ...prev,
                  'what-can-we-help-you-with': e.target.value,
                }))
              }
              className="w-full border-[1px] bg-transparent text-gray-50 border-gray-300 flex justify-between px-4 h-12 items-center rounded-[2px] outline-none  text-base font-normal font-Mulish focus:ring-0 focus:outline-offset-0 focus:border-purple-600 focus:border-[1px]  focus:outline-[3px] focus:outline-[#9E74EC]/[0.3]"
            >
              <option value="" className="text-gray-900">
                Select
              </option>
              <option value=" Tattoos" className="text-gray-900">
                Tattoos
              </option>
              <option value="Piercing" className="text-gray-900">
                Piercing
              </option>
              <option value="Careers" className="text-gray-900">
                Careers
              </option>
              <option value="General" className="text-gray-900">
                General
              </option>
            </select>
          </div>
          <div className="w-full mb-6">
            <label
              htmlFor="description"
              className="font-Gentium-Plus text-sm font-semibold text-gray-50 "
            >
              Message (optional)
            </label>
            <textarea
              type="text"
              value={state.description}
              onChange={(e) =>
                setState((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
              name="description"
              id="description"
              cols="30"
              rows="10"
              className="w-full text border-[1px] font-Gentium-Plus bg-transparent text-gray-50 pl-4 pt-4 border-gray-300 rounded-[2px] min-h-[136px] max-h-[136px] mt-2 focus:outline-[3px] focus:outline-offset-0 focus:ring-0 focus:border-purple-600 focus:outline-[#9E74EC]/[0.3]"
            ></textarea>
          </div>
          <div className="flex gap-2 mb-4">
            <input
              type="checkbox"
              name="optIn"
              id="opt-in"
              checked={state.optIn}
              onChange={() =>
                setState((prev) => ({
                  ...prev,
                  optIn: !state.optIn,
                }))
              }
              className=" w-[24px] h-[24px] form-input regular_check_box"
            />
            <label
              htmlFor="opt-in"
              className="flex-1 text-gray-50 font-Gentium-Plus text-[14px] font-normal not-italic leading-5 "
            >
              Opt in to receive news and updates.
            </label>
          </div>
          <Button label="Submit" />
        </form>
      </div>
    </div>
  )
}

export default ContactForm
